<template>
  <div class="shop-info shop-offers-base">
    <div class="l-container shop-info__content">
      <div class="shop-info__content-block">
        <h2 class="shop-info__content-block-item">Юридическая информация</h2>
        <ul>
          <li>
            <div class="label">Юр. лицо</div>
            <div class="value">{{ ShopInfo.legalname }}</div>
          </li>
          <li>
            <div class="label">ОГРН</div>
            <div class="value">{{ ShopInfo.ogrn }}</div>
          </li>
          <li>
            <div class="label">Юр. адрес</div>
            <div class="value">{{ ShopInfo?.offices[0]?.addr }}</div>
          </li>
        </ul>
      </div>

      <div class="shop-info__content-block">
        <h2 class="shop-info__content-block-item">Как работаем</h2>
        <ul>
          <li>
            <div class="label">Способы оплаты</div>
            <div class="value">
              <div class="value">
                <span v-if="!ShopInfo.payment_options">Нет данных</span>
                <span
                  v-for="item in ShopInfo.payment_options"
                  :key="`${item}_payment`"
                  class="item-dotted"
                >
                  {{ item }}
                </span>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="shop-info__content-block">
        <h2 class="shop-info__content-block-item">Контакты</h2>
        <ul>
          <li>
            <div class="label">Телефон</div>
            <div class="value">
              <span
                v-for="phone in ShopInfo?.offices[0]?.phones"
                :key="phone"
                class="item-dotted"
              >
                {{ phone }}
              </span>
            </div>
          </li>
        </ul>
      </div>

      <div class="shop-info__content-block">
        <h2 class="shop-info__content-block-item">Часы работы</h2>
        <ul :class="{ normal: EqWorkDays }">
          <li>
            <div class="label">Будни</div>
            <div v-if="EqWorkDays" class="value">
              {{ ShopInfo.offices[0]?.work_day[0] || 'Закрыто' }}
            </div>
            <div v-else class="value">
              <div
                v-for="(day, index) in ['пн: ', 'вт: ', 'ср: ', 'чт: ', 'пт: ']"
                :key="index"
              >
                {{ day }}{{ ShopInfo.offices[0]?.work_day[index] || 'Закрыто' }}
              </div>
            </div>
          </li>
          <li>
            <div class="label">Суббота</div>
            <div class="value">
              {{ ShopInfo.offices[0]?.work_day[5] || 'Закрыто' }}
            </div>
          </li>
          <li>
            <div class="label">Воскресенье</div>
            <div class="value">
              {{ ShopInfo.offices[0]?.work_day[6] || 'Закрыто' }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DynamicPageContext } from '~/interfaces/api';

const props = defineProps({
  data: {
    type: Object as () => DynamicPageContext,
    required: true,
  },
  pageData: {
    type: Object as any,
    required: true,
  },
});
const ShopInfo = ref<any>(props.pageData.shopOffers.shopinfo);
const EqWorkDays = computed(() => {
  for (let day = 0; day < 4; day++)
    if (
      props.pageData.shopOffers.shopinfo.offices[0]?.work_day[day] !==
      props.pageData.shopOffers.shopinfo.offices[0]?.work_day[0]
    )
      return false;
  return true;
});
</script>
<style scoped lang="scss" src="./ShopInfoScss.scss"></style>
